import { Nullable } from '@/types/utility';

const SECURITY_TYPES_WITHOUT_PASSWORD = ['', '--', 'OWE', 'OWE-TM'];

export const isWifiSecurityWithoutPassword = (security: Nullable<string>): boolean =>
  security == null || SECURITY_TYPES_WITHOUT_PASSWORD.includes(security);
